// extracted by mini-css-extract-plugin
export default {"textContainer":"CommentCell_textContainer__hR5V0","toggleIcon":"CommentCell_toggleIcon__GCaPJ","fadeIn":"CommentCell_fadeIn__k9i29"};